import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import {
  getDetallesEncabezado,
  getEncabezadoById,
} from "../../../../../API/Finanzas/Retencion/ComprobanteRetencionRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { ReporteComprobanteRetencionLang } from "./ReporteComprobanteRetencionLang";
import { getDateString, getDateTextSmallIdioma } from "../../../../../Base/Services/Moment/Luxon";
import { formatNumberDecimal } from "../../../../../Base/Services/FormatTemplate";

const ReporteComprobanteRetencion = ({
  reporteDialog,
  setReporteDialog,
  datosReporte,
  setDatosReporte,
}) => {
  const [loading, setLoading] = useState(false);
  const [totalImporte, setTotalImporte] = useState(0);
  const [idioma, setIdioma] = useState(1);
  const [IdMoneda, setIdMoneda] = useState(1);
  const [datos, setDatos] = useState([]);
  const [data, setData] = useState([]);
  const [dataEmpresa, setDataEmpresa] = useState([]);

  const obtenerInformacion = async () => {
    setLoading(true);

    const resultEnc = await getEncabezadoById(
      datosReporte?.IdComprobanteRetencionEnc
    );
    setDatos(resultEnc[0]);

    const result = await getDetallesEncabezado(
      datosReporte?.IdComprobanteRetencionEnc
    );
    setData(result);

    const infoEmpresaTempo = await getInformacionEmpresa();
    setDataEmpresa(infoEmpresaTempo[0]);

    if (result.length > 0) {
      let total = resultEnc[0].IdMoneda === 1 ? resultEnc[0].MontoL : resultEnc[0].MontoD;
      setIdMoneda(resultEnc[0]?.IdMoneda);

      setTotalImporte(total);

      GenerarReportePDF(resultEnc[0], result, 1, resultEnc[0]?.IdMoneda, infoEmpresaTempo[0]);
    }

    setLoading(false);
  };

  const infoConcepto = (enc, Language) => {
    let InfotextoRetencion;
    if (enc?.CodigoRetencion) {
      return (InfotextoRetencion =
        Language === "es" ? enc.ContenidoArticuloES : enc?.ContenidoArticuloEN);
    }
  };

  const colum = (moneda, valor, estilo, tama) => {
    return {
      columns:

        [
          { text: moneda, style: estilo, width: 10 },
          { text: `${formatNumberDecimal(valor)}`, style: estilo, width: tama - 10 },
        ]
    }
  }

  const GenerarReportePDF = (enc, detalles, Idioma, IdMon, infoEmpresa) => {
    let Language = Idioma === 1 ? "es" : "en";

    const concepto = infoConcepto(enc, Language);

    let marca = enc.IdEstado === 92 ? {
            text: "ANULADO",
            color: "gray",
            opacity: 0.5,
            bold: true,
            italics: false,
            angle: -25,
            fontSize: 120,
            margin: [0, -50, 0, 0],
          } : { text: "" };

    let contenidoAnulado = [
      {
        columns: [
          {
            image: infoEmpresa?.LogoPrimarioB64,
            width: 200,
            margin: [-10, -10, -10, -10],
          },
          [
            {
              text: `${getLabel(
                ReporteComprobanteRetencionLang,
                "TituloComprobante",
                Language
              )}\n Nº ${enc.NoComprobanteRetencion}`,
              style: "numeroDoc",
              margin: [100, 35, 0, 0],
              width: 100,
            },
          ],
        ],
      },
      {
        columns: [
          [
            {
              text: `${infoEmpresa?.Direccion}`,
              style: "tituloGrandes",
              width: 210,
              margin: [15, 0, 0, 0],
            },
            {
              margin: [10, -5, 0, 0],
              table: {
                headerRows: 1,
                widths: [30, 210],
                body: [
                  [
                    {
                      text: "TEL:",
                      style: "titulo",
                      border: [false, false, false, false],
                    },
                    {
                      text: `${infoEmpresa?.Telefono}`,
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-20, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: "RTN:",
                      style: "titulo",
                      border: [false, false, false, false],
                    },
                    {
                      text: `${infoEmpresa?.RTN}`,
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-20, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: "EMAIL:",
                      style: "titulo",
                      border: [false, false, false, false],
                    },
                    {
                      text: `${infoEmpresa?.CorreoInformativo}`,
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-10, 0, 0, 0],
                    },
                  ],
                  // [
                  //   {
                  //     text: "EMAIL:",
                  //     style: "titulo",
                  //     border: [false, false, false, false],
                  //   },
                  //   {
                  //     text: "administracion@ppf.com.hn ",
                  //     style: "textoEnc2",
                  //     border: [false, false, false, false],
                  //     margin: [-10, 0, 0, 0],
                  //   },
                  // ],
                ],
              },
            },
          ],

          [
            {
              margin: [5, 5, 0, 0],
              table: {
                headerRows: 1,
                widths: [70, 210],
                body: [
                  [
                    {
                      text: `${getLabel(
                        ReporteComprobanteRetencionLang,
                        "TituloProveedor",
                        Language
                      )}`,
                      colSpan: 2,
                      width: 70,
                      style: "titulo",
                      border: [false, false, false, false],
                    },
                    {},
                  ],
                  [
                    {
                      text: `${getLabel(
                        ReporteComprobanteRetencionLang,
                        "Persona",
                        Language
                      )}`,
                      style: "titulo",
                      width: 45,
                      border: [false, false, false, false],
                    },
                    {
                      text: "",
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-28, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        ReporteComprobanteRetencionLang,
                        "RTN",
                        Language
                      )}`,
                      style: "titulo",
                      width: 45,
                      border: [false, false, false, false],
                    },
                    {
                      text: "",
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-30, 0, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        ReporteComprobanteRetencionLang,
                        "CAI",
                        Language
                      )}`,
                      style: "titulo",
                      width: 45,
                      border: [false, false, false, false],
                    },
                    {
                      text: "",
                      style: "textoEnc2",
                      border: [false, false, false, false],
                      margin: [-30, 0, 0, 0],
                    },
                  ],
                ],
              },
            },

            {
              margin: [10, 0, 0, 0],
              columns: [
                {
                  text: `${getLabel(
                    ReporteComprobanteRetencionLang,
                    "FechaEmision",
                    Language
                  )}`,
                  style: "titulo",
                  width: 50,
                },
                { text: "", style: "textoEnc2" },
              ],
            },
            // }
          ],
        ],
      },

      {
        margin: [14, 10, 0, 0],
        columns: [
          {
            text: `${getLabel(
              ReporteComprobanteRetencionLang,
              "Rango",
              Language
            )}`,
            style: "textRangos",
            width: 80,
          },
          {
            text: `${enc.PrefijoRangoInicial} al `,
            style: "textRangos2",
            width: 80,
            margin: [-17, 0, 0, 0],
          },
          {
            text: `${enc.PrefijoRangoFinal}`,
            style: "textRangos2",
            width: 80,
            margin: [-10, 0, 0, 0],
          },
          {
            text: `${getLabel(
              ReporteComprobanteRetencionLang,
              "LimiteEmisión",
              Language
            )}`,
            style: "textRangos",
            width: 80,
          },
          {
            text: getDateString(new Date(enc.FechaVencimiento)),
            style: "textRangos2",
            width: 50,
            margin: [-15, 0, 0, 0],
          },
          {
            text: `${getLabel(
              ReporteComprobanteRetencionLang,
              "CAI",
              Language
            )}`,
            style: "textRangos",
            width: 20,
            margin: [-15, 0, 0, 0],
          },
          {
            text: enc.CAI,
            style: "textRangos2",
            width: 150,
            margin: [-15, 0, 0, 0],
          },
        ],
      },

      IdMon !== 3
        ? {
            margin: [15, 15, 0, 0],
            table: {
              headerRows: 1,
              widths: [50, 185, 80, 35, 50, 20, 50],

              body: [
                [
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "conceptoRetencion",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "descripcionImpuesto",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "NDocumento",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Fecha",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "BaseRetencion",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Tasa",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "ImporteTotal",
                      Language
                    )}`,
                    style: "textCentradoBodyBold",
                  },
                ],

                [
                  { text: "", style: "textCentradoBody" },
                  { text: "", style: "textoEnc" },
                  { text: "", style: "textCentradoBody" },
                  { text: "", style: "textCentradoBody" },
                  {
                    text: `${formatNumberDecimal(0)}`,
                    style: "textCentradoBody2",
                  },
                  { text: `${0}%`, style: "textCentradoBody" },
                  {
                    text: ` ${formatNumberDecimal(0)}`,
                    style: "textCentradoBody2",
                  },
                ],
                [
                  {
                    text: "Total",
                    style: "textEnc3",
                    colSpan: 6,
                    border: [true, true, true, true],
                  },
                  {},
                  {},
                  {},
                  {},
                  {},
                  colum(
                    `${IdMon === 1 ? "L" : "$"}`,
                    `${0}`,
                    "textCentradoBody2",
                    50
                  ),
                  // { text: ` $ ${formatNumber(montoTotal)}`,style:'textCentradoBody2'  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0.5;
              },
              vLineWidth: function (i, node) {
                return 0.5;
              },
              hLineColor: function (i, node) {
                return "gray";
              },
              vLineColor: function (i, node) {
                return "gray";
              },
            },
          }
        : {
            margin: [15, 15, 0, 0],
            table: {
              headerRows: 1,
              widths: [40, 100, 80, 35, 46, 46, 20, 46, 46],

              body: [
                [
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "conceptoRetencion",
                      Language
                    )}`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "descripcionImpuesto",
                      Language
                    )}`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "NDocumento",
                      Language
                    )}`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Fecha",
                      Language
                    )}`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "BaseRetencion",
                      Language
                    )}  $`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "BaseRetencion",
                      Language
                    )}  L `,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Tasa",
                      Language
                    )}`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "ImporteTotal",
                      Language
                    )} $`,
                    style: "textCentradoBodyBold2",
                  },
                  {
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "ImporteTotal",
                      Language
                    )} L`,
                    style: "textCentradoBodyBold2",
                  },
                ],

                [
                  { text: "", style: "textCentradoBody2" },
                  { text: "", style: "textoEnc2" },
                  { text: "", style: "textCentradoBody2" },
                  { text: "", style: "textCentradoBody2" },
                  { text: formatNumberDecimal(0), style: "textCentradoBody21" },
                  { text: formatNumberDecimal(0), style: "textCentradoBody21" },
                  { text: `${0}%`, style: "textCentradoBody" },
                  { text: formatNumberDecimal(0), style: "textCentradoBody21" },
                  { text: formatNumberDecimal(0), style: "textCentradoBody21" },
                ],
                [
                  {
                    text: "Total",
                    style: "textEnc3",
                    colSpan: 7,
                    border: [true, true, true, true],
                  },
                  {},
                  {},
                  {},
                  {},
                  {},
                  {},
                  colum("$", 0, "textCentradoBody21", 44),
                  colum("L", 0, "textCentradoBody21", 44),
                  // { text: ` $ ${formatNumber(montoTotal)}`,style:'textCentradoBody2'  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0.5;
              },
              vLineWidth: function (i, node) {
                return 0.5;
              },
              hLineColor: function (i, node) {
                return "gray";
              },
              vLineColor: function (i, node) {
                return "gray";
              },
            },
          },
      {
        text: `${getLabel(
          ReporteComprobanteRetencionLang,
          "Original",
          Language
        )} \n ${getLabel(ReporteComprobanteRetencionLang, "Copia", Language)}`,
        style: "textoEnc2",
        margin: [20, 10, 10, 10],
      },
      {
        columns: [
          {
            margin: [100, 40, 0, 0],

            table: {
              widths: [100, 20, 100, 20, 100],
              body: [
                [
                  { text: "", border: [false, false, false, true] },
                  { text: "", border: [false, false, false, false] },
                  { text: "", border: [false, false, false, true] },
                  { text: "", border: [false, false, false, false] },
                  { text: "", border: [false, false, false, true] },
                ],
                [
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Emitido",
                      Language
                    )}`,
                    style: "firmas",
                    width: [80],
                  },
                  {
                    border: [false, false, false, false],
                    text: "",
                    width: [100],
                  },
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Revisado",
                      Language
                    )}`,
                    style: "firmas",
                    width: [80],
                  },
                  {
                    border: [false, false, false, false],
                    text: "",
                    width: [100],
                  },
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(
                      ReporteComprobanteRetencionLang,
                      "Autorizado",
                      Language
                    )}`,
                    style: "firmas",
                    width: [80],
                  },
                ],
              ],
            },
          },
        ],
      },
    ];

    const contenido = [
      {
        columns: [
          {
            image: infoEmpresa?.LogoPrimarioB64,
            width: 200,
            margin: [-10, -10, -10, -10]
          },
          [
            { text: `${getLabel(ReporteComprobanteRetencionLang, 'TituloComprobante', Language)}\n Nº ${enc.NoComprobanteRetencion}`, style: 'numeroDoc', margin: [100, 35, 0, 0], width: 100 },
          ],

        ]
      }
      , {
        columns: [
          [
            {
              text: `${infoEmpresa?.Direccion}`,
              style: 'tituloGrandes', width: 210, margin: [15, 0, 0, 0]
            },
            {
              margin: [10, -5, 0, 0],
              table: {
                headerRows: 1,
                widths: [30, 210],
                body: [
                  [{ text: 'TEL:', style: 'titulo', border: [false, false, false, false] }, { text: `${infoEmpresa?.Telefono}`, style: 'textoEnc2', border: [false, false, false, false], margin: [-20, 0, 0, 0] },],
                  [{ text: 'RTN:', style: 'titulo', border: [false, false, false, false] }, { text: `${infoEmpresa?.RTN}`, style: 'textoEnc2', border: [false, false, false, false], margin: [-20, 0, 0, 0] },],
                  [{ text: 'EMAIL:', style: 'titulo', border: [false, false, false, false] }, { text: `${infoEmpresa?.CorreoInformativo}`, style: 'textoEnc2', border: [false, false, false, false], margin: [-10, 0, 0, 0] },],
                  // [{ text: 'EMAIL:', style: 'titulo', border: [false, false, false, false] }, { text: 'administracion@ppf.com.hn ', style: 'textoEnc2', border: [false, false, false, false], margin: [-10, 0, 0, 0] },],
                ],
              }
            },
          ],

          [

            {
              margin: [5, 5, 0, 0],
              table: {
                headerRows: 1,
                widths: [70, 210],
                body: [
                  [{ text: `${getLabel(ReporteComprobanteRetencionLang, 'TituloProveedor', Language)}`, colSpan: 2, width: 70, style: 'titulo', border: [false, false, false, false] }, {},],
                  [{ text: `${getLabel(ReporteComprobanteRetencionLang, 'Persona', Language)}`, style: 'titulo', width: 45, border: [false, false, false, false] }, { text: enc.NombreSucursal, style: 'textoEnc2', border: [false, false, false, false], margin: [-28, 0, 0, 0] },],
                  // [{ text: `${getLabel(ReporteComprobanteRetencionLang, 'RTN', Language)}`, style: 'titulo', width: 45, border: [false, false, false, false] }, { text: enc.RTN, style: 'textoEnc2', border: [false, false, false, false], margin: [-30, 0, 0, 0] },],
                  [{ text: `${getLabel(ReporteComprobanteRetencionLang, 'CAI', Language)}`, style: 'titulo', width: 45, border: [false, false, false, false] }, { text: enc.NoCAI, style: 'textoEnc2', border: [false, false, false, false], margin: [-30, 0, 0, 0] },],

                ],

              },

            },

            {
              margin: [10, 0, 0, 0],
              columns: [
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'FechaEmision', Language)}`, style: 'titulo', width: 50 },
                { text: getDateTextSmallIdioma(new Date(enc.FechaEmision), Language), style: 'textoEnc2', }
              ]
            }
            // }
          ],

        ]
      },

      {
        margin: [14, 10, 0, 0],
        columns: [
          { text: `${getLabel(ReporteComprobanteRetencionLang, 'Rango', Language)}`, style: 'textRangos', width: 80 },
          { text: `${enc.PrefijoRangoInicial} al `, style: 'textRangos2', width: 80, margin: [-17, 0, 0, 0] },
          { text: `${enc.PrefijoRangoFinal}`, style: 'textRangos2', width: 80, margin: [-10, 0, 0, 0] },
          { text: `${getLabel(ReporteComprobanteRetencionLang, 'LimiteEmisión', Language)}`, style: 'textRangos', width: 80 },
          { text: getDateString(new Date(enc.FechaVencimiento)), style: 'textRangos2', width: 50, margin: [-15, 0, 0, 0] },
          { text: `${getLabel(ReporteComprobanteRetencionLang, 'CAI', Language)}`, style: 'textRangos', width: 20, margin: [-15, 0, 0, 0] },
          { text: enc.CAI, style: 'textRangos2', width: 150, margin: [-15, 0, 0, 0]}
        ]
      },

      IdMon !== 3 ? (
        {
          margin: [15, 15, 0, 0],
          table: {
            headerRows: 1,
            widths: [50, 185, 80, 35, 50, 20, 50],

            body: [
              [
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'conceptoRetencion', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'descripcionImpuesto', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'NDocumento', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'Fecha', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'BaseRetencion', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'Tasa', Language)}`, style: 'textCentradoBodyBold' },
                { text: `${getLabel(ReporteComprobanteRetencionLang, 'ImporteTotal', Language)}`, style: 'textCentradoBodyBold' },
              ],
              ...detalles.map(item =>
                [
                  { text: item.CodigoRetencion, style: 'textCentradoBody' },
                  { text: item.DescripcionImpuestoRetenido, style: 'textoEnc' },
                  { text: item.NoDocumento, style: 'textCentradoBody' },
                  { text: item.FechaDocumentoStr, style: 'textCentradoBody' },
                  { text: `${IdMon === 1 ? formatNumberDecimal(item.MontoL) : formatNumberDecimal(item.MontoD)}`, style: 'textCentradoBody2' },
                  { text: `${item.Tasa}%`, style: 'textCentradoBody' },
                  { text: ` ${IdMon === 1 ? formatNumberDecimal(item.ImporteTotalL) : formatNumberDecimal(item.ImporteTotalD)}`, style: 'textCentradoBody2' }
                ]
              ),

              [
                { text: 'Total', style: 'textEnc3', colSpan: 6, border: [true, true, true, true] }, {},
                {}, {}, {}, {},
                colum(`${IdMon === 1 ? 'L' : '$'}`, `${IdMon === 1 ? enc.MontoL : enc.MontoD}`, 'textCentradoBody2', 50),
                // { text: ` $ ${formatNumber(montoTotal)}`,style:'textCentradoBody2'  },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0.5;
            },
            vLineWidth: function (i, node) {
              return 0.5;
            },
            hLineColor: function (i, node) {
              return 'gray';
            },
            vLineColor: function (i, node) {
              return 'gray';
            },
          }
        }) :
        (
          {
            margin: [15, 15, 0, 0],
            table: {
              headerRows: 1,
              widths: [40, 100, 80, 35, 46, 46, 20, 46, 46],

              body: [
                [
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'conceptoRetencion', Language)}`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'descripcionImpuesto', Language)}`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'NDocumento', Language)}`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'Fecha', Language)}`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'BaseRetencion', Language)}  $`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'BaseRetencion', Language)}  L `, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'Tasa', Language)}`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'ImporteTotal', Language)} $`, style: 'textCentradoBodyBold2' },
                  { text: `${getLabel(ReporteComprobanteRetencionLang, 'ImporteTotal', Language)} L`, style: 'textCentradoBodyBold2' },
                ],
                ...detalles.map(item =>
                  [
                    { text: item.CodigoRetencion, style: 'textCentradoBody2' },
                    { text: item.DescripcionImpuestoRetenido, style: 'textoEnc2' },
                    { text: item.NoDocumento, style: 'textCentradoBody2' },
                    { text: item.FechaDocumento, style: 'textCentradoBody2' },
                    { text: formatNumberDecimal(item.MontoD), style: 'textCentradoBody21' },
                    { text: formatNumberDecimal(item.MontoL), style: 'textCentradoBody21' },
                    { text: `${item.Tasa}%`, style: 'textCentradoBody' },
                    { text: formatNumberDecimal(item.ImporteTotalD), style: 'textCentradoBody21' },
                    { text: formatNumberDecimal(item.ImporteTotalL), style: 'textCentradoBody21' },
                  ]
                ),

                [
                  { text: 'Total', style: 'textEnc3', colSpan: 7, border: [true, true, true, true] },
                  {}, {}, {}, {}, {}, {},
                  colum('$', enc.MontoD, 'textCentradoBody21', 44),
                  colum('L', enc.MontoL, 'textCentradoBody21', 44),
                  // { text: ` $ ${formatNumber(montoTotal)}`,style:'textCentradoBody2'  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0.5;
              },
              vLineWidth: function (i, node) {
                return 0.5;
              },
              hLineColor: function (i, node) {
                return 'gray';
              },
              vLineColor: function (i, node) {
                return 'gray';
              },
            }
          }),
      { text: `${getLabel(ReporteComprobanteRetencionLang, 'Original', Language)} \n ${getLabel(ReporteComprobanteRetencionLang, 'Copia', Language)}`, style: 'textoEnc2', margin: [20, 10, 10, 10] },
      {
        columns: [
          {
            margin: [100, 40, 0, 0],

            table: {
              widths: [100, 20, 100, 20, 100],
              body: [
                [
                  { text: '', border: [false, false, false, true] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, true] },
                  { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, true] },
                ],
                [
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(ReporteComprobanteRetencionLang, 'Emitido', Language)}`,
                    style: 'firmas', width: [80]
                  },
                  {
                    border: [false, false, false, false],
                    text: '', width: [100]
                  },
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(ReporteComprobanteRetencionLang, 'Revisado', Language)}`,
                    style: 'firmas', width: [80]
                  },
                  {
                    border: [false, false, false, false],
                    text: '', width: [100]
                  },
                  {
                    border: [false, true, false, false],
                    text: `${getLabel(ReporteComprobanteRetencionLang, 'Autorizado', Language)}`,
                    style: 'firmas', width: [80]
                  },
                ]

              ]
            }
          }
        ]

      },
      {
        text: `${concepto}`, style: 'textoEnc', margin: [20, 20, 35, 0]
      }
    ]

    const docDefinition = {

      pageSize: 'LETTER',
      pageOrientation: 'portrait',
      pageMargins: [20, 20, 10, 20],
      watermark: marca,

      content: enc?.IdEstado !== 92 ? contenido : contenidoAnulado,
      // content: contenido,
      styles: {
        tituloGrandes: {
          fontSize: 8.5,
          bold: true,
          alignment: 'justify',
          lineHeight: 1.5
        },

        titulo: {
          fontSize: 8,
          bold: true,
          alignment: 'justify'
        },
        numeroDoc: {
          fontSize: 9,
          bold: true,
          alignment: 'center',
          lineHeight: 1.5
        },
        textoEnc: {
          fontSize: 8,
          alignment: 'justify'
        },
        textoEnc2: {
          fontSize: 7.5,
          alignment: 'left'
        },
        textEnc3: {
          fontSize: 8,
          alignment: 'right',
          bold: true,
        },
        textRangos: {
          fontSize: 7.5,
          bold: true,
        },
        textRangos2: {
          fontSize: 7.5,
          alignment: 'left',
        },
        textCentradoBody: {
          fontSize: 8,
          alignment: 'center'
        },
        textCentradoBodyBold: {
          fontSize: 8,
          alignment: 'center',
          bold: true,
        },
        textCentradoBody2: {
          fontSize: 8,
          alignment: 'right'
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: 'center',
          lineHeight: 1

        },
        textConcepto: {
          fontSize: 8,
          alignment: "justify",
          lineHeight: 1

        },

        textCentradoBody2: {
          fontSize: 7,
          alignment: 'center'
        },
        textCentradoBodyBold2: {
          fontSize: 7,
          alignment: 'center',
          bold: true,
        },
        textCentradoBody21: {
          fontSize: 7,
          alignment: 'right'
        },
        textConcepto2: {
          fontSize: 7,
          alignment: "justify",
          lineHeight: 1

        },
      }
    }

    let doc = pdfMake.createPdf(docDefinition);
    let f = document.getElementById('foo');
    let callback = function (url) { f.setAttribute('src', url); }
    doc.getDataUrl(callback, doc);
  };

  const hideDialogReporte = () => {
    setReporteDialog(false);
    setDatosReporte(null);
  };

  const Idiomas = [
    {
      Id: 1,
      Idioma: "Español",
    },
    {
      Id: 2,
      Idioma: "Ingles",
    },
  ];

  const MostrasValores = [
    {
      IdValores: 1,
      Valores: "Lempiras",
    },
    {
      IdValores: 2,
      Valores: "Dolares",
    },
    {
      IdValores: 3,
      Valores: "Lempiras Y Dolares",
    },
  ];

  const cambiarIdioma = (Id, IdMon) => {
    setIdioma(Id);
    setIdMoneda(IdMon);
    GenerarReportePDF(datos, data, Id, IdMon, dataEmpresa);
  };

  const encabezado = (
    <div className="d-flex flex-row mt-4">
      <h3>Reporte Comprobante de Retención </h3>
      <div className="p-float-label">
        <Dropdown
          value={idioma}
          onChange={(e) => cambiarIdioma(e.value, IdMoneda)}
          options={Idiomas}
          optionValue="Id"
          optionLabel="Idioma"
          style={{ width: 200 }}
          className="mx-2"
        />
        <label htmlFor="username">Idioma</label>
      </div>
      <div className="p-float-label">
        <Dropdown
          value={IdMoneda}
          onChange={(e) => cambiarIdioma(idioma, e.value)}
          options={MostrasValores}
          optionValue="IdValores"
          optionLabel="Valores"
          style={{ width: 200 }}
          className="mx-2"
        />
        <label htmlFor="username">Moneda</label>
      </div>
    </div>
  );

  useEffect(() => {
    if (reporteDialog) {
      obtenerInformacion();
    } else {
      setIdioma(1);
    }
  }, [reporteDialog]);

  return (
    <div>
      <Dialog
        visible={reporteDialog}
        header={encabezado}
        onHide={hideDialogReporte}
      >
        <div id="Reporte">
          <Loader loading={loading} querySelector="#Reporte" />
          <iframe
            src={""}
            style={{ width: "75vw", height:"70vh", border: "1px solid #ccc" }}
            id="foo"
          />
        </div>
      </Dialog>
    </div>
  );
};

export default ReporteComprobanteRetencion;
